import { HStack, Text } from '@chakra-ui/react';
import { CircleArrowIcon, CloudSuccessIcon } from 'assets/icons/v2';
import { NovaIcon } from 'components/ui/novaIcon';
import React, { ReactElement } from 'react';

type Props = {
  isSaved: boolean;
};

export const SaveIndicator = ({ isSaved }: Props): ReactElement => {
  return (
    <HStack gap="10px">
      <Text textStyle="body.m.regular" color="text.tertiary">
        {isSaved ? 'Gespeichert' : 'Speichern...'}
      </Text>
      {isSaved ? (
        <NovaIcon icon={CloudSuccessIcon} size="l" color="icon.tertiary" aria-hidden />
      ) : (
        <NovaIcon icon={CircleArrowIcon} size="l" color="icon.tertiary" aria-hidden />
      )}
    </HStack>
  );
};
